module.exports = Jsw.skinUrl + "/images/notification-center-empty.svg?f6f02fc885a503b392c5428b65337ef7";